import { render, staticRenderFns } from "./PublicRecipes.vue?vue&type=template&id=1d340e50&"
import script from "./PublicRecipes.vue?vue&type=script&lang=js&"
export * from "./PublicRecipes.vue?vue&type=script&lang=js&"
import style0 from "./PublicRecipes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports